export default __webpack_public_path__ + "static/media/sky_bg_muted.1a846acf.png";